import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
} from '@mui/material';

// Deck 1 - 9 cartas
import deck1_1 from '../../imgs/jogos/jogo-memoria-1/img-1.png';
import deck1_2 from '../../imgs/jogos/jogo-memoria-1/img-2.png';
import deck1_3 from '../../imgs/jogos/jogo-memoria-1/img-3.png';
import deck1_4 from '../../imgs/jogos/jogo-memoria-1/img-4.png';
import deck1_5 from '../../imgs/jogos/jogo-memoria-1/img-5.png';
import deck1_6 from '../../imgs/jogos/jogo-memoria-1/img-6.png';
import deck1_7 from '../../imgs/jogos/jogo-memoria-1/img-7.png';
import deck1_8 from '../../imgs/jogos/jogo-memoria-1/img-8.png';
import deck1_9 from '../../imgs/jogos/jogo-memoria-1/img-9.png';

// Deck 2 - 6 cartas
import deck2_1 from '../../imgs/jogos/jogo-memoria-2/img-1.png';
import deck2_2 from '../../imgs/jogos/jogo-memoria-2/img-2.png';
import deck2_3 from '../../imgs/jogos/jogo-memoria-2/img-3.png';
import deck2_4 from '../../imgs/jogos/jogo-memoria-2/img-4.png';
import deck2_5 from '../../imgs/jogos/jogo-memoria-2/img-5.png';
import deck2_6 from '../../imgs/jogos/jogo-memoria-2/img-6.png';

// Deck 3 - 6 cartas
import deck3_1 from '../../imgs/jogos/jogo-memoria-3/img-1.png';
import deck3_2 from '../../imgs/jogos/jogo-memoria-3/img-2.png';
import deck3_3 from '../../imgs/jogos/jogo-memoria-3/img-3.png';
import deck3_4 from '../../imgs/jogos/jogo-memoria-3/img-4.png';
import deck3_5 from '../../imgs/jogos/jogo-memoria-3/img-5.png';
import deck3_6 from '../../imgs/jogos/jogo-memoria-3/img-6.png';

// Deck 4 - 7 cartas
import deck4_1 from '../../imgs/jogos/jogo-memoria-4/img-1.png';
import deck4_2 from '../../imgs/jogos/jogo-memoria-4/img-2.png';
import deck4_3 from '../../imgs/jogos/jogo-memoria-4/img-3.png';
import deck4_4 from '../../imgs/jogos/jogo-memoria-4/img-4.png';
import deck4_5 from '../../imgs/jogos/jogo-memoria-4/img-5.png';
import deck4_6 from '../../imgs/jogos/jogo-memoria-4/img-6.png';
import deck4_7 from '../../imgs/jogos/jogo-memoria-4/img-7.png';

import backImage from '../../imgs/jogos/carta-verso.png';
import { useIsMobile } from '../../hooks/useIsMobile';

const decks = [
  [deck1_1, deck1_2, deck1_3, deck1_4, deck1_5, deck1_6, deck1_7, deck1_8, deck1_9],
  [deck2_1, deck2_2, deck2_3, deck2_4, deck2_5, deck2_6],
  [deck3_1, deck3_2, deck3_3, deck3_4, deck3_5, deck3_6],
  [deck4_1, deck4_2, deck4_3, deck4_4, deck4_5, deck4_6, deck4_7],
];

function JogoDaMemoria() {
  const [cartas, setCartas] = useState([]);
  const [cartasViradas, setCartasViradas] = useState([]);
  const [paresEncontrados, setParesEncontrados] = useState([]);
  const [bloquear, setBloquear] = useState(false);
  const [tentativas, setTentativas] = useState(0);
  const [mostrarDialog, setMostrarDialog] = useState(false);
  const [nome, setNome] = useState('');

  const isMobile = useIsMobile();

  useEffect(() => {
    const deckAleatorio = decks[Math.floor(Math.random() * decks.length)];
    const duplicadas = [...deckAleatorio, ...deckAleatorio];
    const embaralhadas = duplicadas
      .map((img, index) => ({ id: index, img }))
      .sort(() => 0.5 - Math.random());
    setCartas(embaralhadas);
  }, []);

  const virarCarta = (index) => {
    if (bloquear || cartasViradas.includes(index) || paresEncontrados.includes(index)) return;

    const novasViradas = [...cartasViradas, index];
    setCartasViradas(novasViradas);

    if (novasViradas.length === 2) {
      setBloquear(true);
      setTentativas((prev) => prev + 1);
      const [firstIndex, secondIndex] = novasViradas;
      const mesmaImagem = cartas[firstIndex].img === cartas[secondIndex].img;

      setTimeout(() => {
        if (mesmaImagem) {
          setParesEncontrados([...paresEncontrados, firstIndex, secondIndex]);
        }
        setCartasViradas([]);
        setBloquear(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (cartas.length > 0 && paresEncontrados.length === cartas.length) {
      setTimeout(() => {
        setMostrarDialog(true);
      }, 800);
    }
  }, [paresEncontrados, cartas]);

  const salvarPontuacao = () => {
    const historico = JSON.parse(localStorage.getItem('jogoMemoriaHistorico')) || [];
    historico.push({ nome, tentativas });
    localStorage.setItem('jogoMemoriaHistorico', JSON.stringify(historico));
    setMostrarDialog(false);
  };

  return (
    <div className='bg-game-1' style={{ paddingTop: isMobile ? 60 : 120, paddingBottom: 120, height: '100vh', textAlign: 'center' }}>
      <div className='container'>
        <Typography variant="h3" gutterBottom>Jogo da Memória</Typography>
        <Typography variant="h6" gutterBottom>Tentativas: {tentativas}</Typography>

        <Grid container spacing={2} justifyContent="center">
          {cartas.map((carta, index) => {
            const estaVirada = cartasViradas.includes(index) || paresEncontrados.includes(index);
            return (
              <Grid item xs={3} sm={2} md={2} key={index}>
                <Card>
                  <CardActionArea onClick={() => virarCarta(index)}>
                    <CardMedia
                      component="img"
                      image={estaVirada ? carta.img : backImage}
                      alt="carta"
                      sx={{
                        width: '100%',
                        height: 'auto',
                        aspectRatio: '1 / 1',
                        objectFit: 'contain',
                      }}
                    />
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>

      <Dialog open={mostrarDialog} onClose={() => setMostrarDialog(false)}>
        <DialogTitle>Parabéns!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Você encontrou todos os pares em {tentativas} tentativas.
          </Typography>
          <TextField
            label="Digite seu nome"
            fullWidth
            margin="dense"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={salvarPontuacao}
          >
            Salvar pontuação
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default JogoDaMemoria;
